export default __webpack_public_path__ + "static/media/sticker-v.ec9bd971.png";